import * as React from 'react';

import { SvgXml } from 'react-native-svg';

type Props = {
    color: string;
    width: number;
    height: number;
    routeKey: string;
};

const Spinner = ({ color, width, height, routeKey }: Props) => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="red"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M24 1.99933C24 0.895132 23.1033 -0.00865457 22.0029 0.0832218C17.9603 0.420762 14.0574 1.7789 10.6663 4.04473C6.71953 6.68188 3.64339 10.4302 1.82689 14.8156C0.0103881 19.201 -0.464892 24.0266 0.461153 28.6822C1.3872 33.3377 3.67298 37.6141 7.02944 40.9706C10.3859 44.327 14.6623 46.6128 19.3178 47.5388C23.9734 48.4649 28.799 47.9896 33.1844 46.1731C37.5698 44.3566 41.3181 41.2805 43.9553 37.3337C46.2211 33.9426 47.5792 30.0397 47.9168 25.9971C48.0087 24.8967 47.1049 24 46.0007 24C44.8965 24 44.0117 24.8974 43.9015 25.9961C43.5755 29.2467 42.4568 32.3789 40.6305 35.1121C38.4327 38.4013 35.3089 40.965 31.6542 42.4788C27.9994 43.9927 23.9778 44.3888 20.0979 43.617C16.2181 42.8453 12.6542 40.9403 9.85692 38.1431C7.05969 35.3458 5.15474 31.7819 4.38299 27.9021C3.61123 24.0222 4.00733 20.0006 5.52118 16.3458C7.03503 12.6911 9.59865 9.56728 12.8879 7.3695C15.6211 5.54323 18.7533 4.42452 22.0039 4.09851C23.1026 3.98831 24 3.10354 24 1.99933Z"
                fill={`url(#paint0_angular${routeKey})`}
            />
            <defs>
                <linearGradient
                    id={`paint0_angular${routeKey}`}
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={color} stopOpacity="1" />
                    <stop offset="100%" stopColor={color} stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
export default Spinner;
